import type { OpcaoEmpregador } from '../catalogo-empregador.tipos'

export type ListarOpcoesEmpregadorRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoEmpregador[]>

export const criarCasoDeUsoListarOpcoesEmpregador = (
  listarNoRepositorio: ListarOpcoesEmpregadorRepositorio,
): ListarOpcoesEmpregadorRepositorio => async (sinal) => (
  listarNoRepositorio(sinal)
)
